module.exports = __webpack_public_path__ + "img/logo.c0028ef0.png";